<div class="container-fluid mt-3">
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-body">
          <div class="row mb-md-2">
            <div class="col-sm-12 col-lg-6 mb-1">
              <div class="dataTables_length" id="tickets-table_length">
                <label class="d-inline-flex align-items-center">
                  Afișează
                  <select
                    name="tickets-table_length"
                    aria-controls="tickets-table"
                    name="pageSize"
                    [(ngModel)]="rapoarteJurnalService.pageSize"
                    [disabled]="loadingDataSpinner"
                    (change)="changeTableRows($event)"
                    class="custom-select custom-select-sm form-control form-control-sm mx-2"
                  >
                    <option value="10">10</option>
                    <option value="30">30</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </select>
                  intrări
                </label>
              </div>
            </div>

            <!-- Search -->
            <div class="col-sm-12 col-lg-6">
              <div
                id="tickets-table_filter"
                class="d-flex justify-content-end"
              >
                <button
                  class="btn btn-info btn-sm"
                  type="button"
                  placement="left"
                  [disabled]="loadingDataSpinner"
                  (click)="openTableSearchModal()"
                >
                  <span class="mdi mdi-magnify"></span>
                  Filtrare
                </button>

                <button
                  class="btn btn-success btn-sm"
                  type="button"
                  (click)="exportTableXLSX()"
                  ngbTooltip="Se vor exporta doar datele afișate"
                  placement="bottom"
                  [disabled]="loadingDataSpinner || rapoarteJurnalLength === 0 || !isDataFiltered"
                >
                  <i class="mdi mdi-file-excel"></i>
                  Exportă XLS
                </button>
              </div>
            </div>
            <!-- End search -->
          </div>

          <!-- Table -->
          <div class="table-responsive" #rapoarteJurnalTable>
            <table
              id="moves-datatable"
              class="table datatables dt-responsive nowrap table-hover"
            >
              <thead>
                <tr>
                  <th sortable="data" (sort)="onSort($event)">Data</th>
                  <th sortable="explicatie" (sort)="onSort($event)">
                    Explicație
                  </th>
                  <th sortable="debit" (sort)="onSort($event)">Debit</th>
                  <th sortable="credit" (sort)="onSort($event)">Credit</th>
                </tr>
              </thead>

              <div
                class="spinner-border text-info table-spinner avatar-lg"
                role="status"
                *ngIf="loadingDataSpinner"
              ></div>

              <ngb-alert
                type="danger"
                class="text-center search-error"
                *ngIf="rapoarteJurnalService.totalRecords === 0 && isDataFiltered"
                [dismissible]="false"
              >
                Nu a fost găsită nici o informatie.
              </ngb-alert>

              <ngb-alert
                type="warning"
                class="text-center search-error"
                *ngIf="rapoarteJurnalService.totalRecords === 0 && !isDataFiltered"
                [dismissible]="false"
              >
                Este necesară filtrarea după o anumită perioadă
              </ngb-alert>

              <tbody [ngClass]="{ disabled: loadingDataSpinner }">
                <tr *ngFor="let raport of rapoarteJurnal" [ngClass]="{cancelled : raport.status === 3}">
                  <td>{{ raport.data }}</td>
                  <td>{{ raport.explicatie }}</td>
                  <td>{{ raport.debit }}</td>
                  <td>{{ raport.credit }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <!-- End table -->
          <div
            class="row justify-content-lg-between align-items-lg-center mt-2"
            *ngIf="rapoarteJurnalService.totalRecords > 0"
          >
            <div class="col-sm-12 col-lg-6">
              <div
                class="dataTables_info mb-2"
                id="tickets-table_info"
                role="status"
                aria-live="polite"
              >
                Afișează de la
                {{ rapoarteJurnalService.startIndex }} la
                {{ rapoarteJurnalService.endIndex }} din
                {{ rapoarteJurnalService.totalRecords }}
                intrări
              </div>
            </div>
            <!-- Pagination -->
            <div class="col-sm-12 col-lg-6">
              <div class="text-lg-right float-lg-right pagination-rounded">
                <ngb-pagination
                  [disabled]="loadingDataSpinner"
                  [collectionSize]="rapoarteJurnalLength"
                  [(page)]="rapoarteJurnalService.page"
                  [pageSize]="rapoarteJurnalService.pageSize"
                  [maxSize]="5"
                  (pageChange)="changeTablePage($event)"
                >
                </ngb-pagination>
              </div>
            </div>
            <!-- End Pagination -->
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<app-table-search-modal
  [open]="openSearchModal"
  [modalType]="modalType"
  (searchingData)="filterSearch($event)"
>
</app-table-search-modal>
